import React from 'react';
import { CheckCircleIcon, CircleIcon } from 'lucide-react';
interface Task {
  title: string;
  completed: boolean;
}
interface ProtocolCardProps {
  title: string;
  description: string;
  progress: number;
  tasks: Task[];
}
export const ProtocolCard: React.FC<ProtocolCardProps> = ({
  title,
  description,
  progress,
  tasks
}) => {
  return <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-1036">
      <div className="p-4" data-id="element-1037">
        <div className="flex items-center justify-between mb-2" data-id="element-1038">
          <h3 className="font-bold text-gray-800" data-id="element-1039">{title}</h3>
          <span className="text-sm text-purple-600 font-medium" data-id="element-1040">
            {progress}% erledigt
          </span>
        </div>
        <p className="text-gray-600 text-sm mb-4" data-id="element-1041">{description}</p>
        <div className="w-full bg-gray-200 rounded-full h-2 mb-4" data-id="element-1042">
          <div className="bg-purple-600 h-2 rounded-full" style={{
          width: `${progress}%`
        }} data-id="element-1043"></div>
        </div>
        <div className="space-y-3" data-id="element-1044">
          {tasks.map((task, index) => <div key={index} className="flex items-center" data-id="element-1045">
              {task.completed ? <CheckCircleIcon size={20} className="text-purple-600 mr-2" data-id="element-1046" /> : <CircleIcon size={20} className="text-gray-300 mr-2" data-id="element-1047" />}
              <span className={task.completed ? 'text-gray-400 line-through' : 'text-gray-800'} data-id="element-1048">
                {task.title}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
};